import { ICellRendererParams } from "ag-grid-community";
import { Component } from "react";
import { ICellRendererReactComp } from "ag-grid-react";
import { Chip } from "@mui/material";
import { AxiosInstance } from "axios";
import { Tag } from "types/portfolio";
import { toast } from "react-toastify";
import { TagType } from "../GridViewFunction/TagRender";
import { AuthDetail } from "types/auth";
import { FEATURE_KEY } from "constant";

interface TagsRendererState {
  tags: Tag[];
}

interface TagsRendererProps extends ICellRendererParams {
  type: TagType;
  axios: AxiosInstance;
  authDetail?: AuthDetail;
}

class TagsRenderer
  extends Component<TagsRendererProps, TagsRendererState>
  implements ICellRendererReactComp
{
  constructor(props: TagsRendererProps) {
    super(props);
    this.handleDelete = this.handleDelete.bind(this);
    // console.log(props.data);
    const type = props.type === "personal-tag" ? "personalTags" : "managementTags";
    const { tags, personalTags, managementTags, ..._extra } = props.data;
    let tagType = 1;
    if (personalTags?.length || managementTags?.length) {
      this.state = {
        tags: props.data[type],
      };
    } else {
      if (props.type === "personal-tag") {
        tagType = 2;
      } else {
        tagType = 1;
      }
      if (tags?.length) {
        this.state = {
          tags: tags.filter((item: any) => item.type == tagType),
        };
      } else {
        this.state = {
          tags: [],
        };
      }
    }
  }

  public refresh() {
    return false;
  }

  handleDelete = (id: string, accountKey: string) => () => {
    this.props.axios
      .delete(`/api/portfolio/tags/${this.props.type}/${id}/${accountKey}`)
      .then(() => {
        const tags = this.state.tags.filter((i) => i.id !== id);
        this.setState({ tags });
        this.props.node.setDataValue(this.props.column, tags);
      })
      .catch(() => {
        toast.error("Fail to delete");
      });
  };

  public render() {
    const { type, authDetail } = this.props;
    const { tags } = this.state;
    const canUnassign =
      type === "management-tag" &&
      authDetail?.features.some((x) => x === FEATURE_KEY.PORTFOLIO_ASSIGN_MANAGER_TAG);
    if (tags.length === 0) return null;
    return (
      <>
        <Chip
          label={tags.length}
          size="small"
          color="primary"
          style={{
            backgroundColor: type === "management-tag" ? "orange" : "#00a0d1",
          }}
        />
        {tags.map((item: Tag) => (
          <Chip
            label={item.name}
            key={item.id}
            style={{
              marginLeft: "10px",
              backgroundColor: type === "management-tag" ? "orange" : "#00a0d1",
            }}
            onDelete={
              type !== "management-tag" || canUnassign
                ? this.handleDelete(item.id, this.props.data.accountKey)
                : undefined
            }
            color="primary"
          />
        ))}
      </>
    );
  }
}

export default TagsRenderer;
